import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";

export const getRateLimitConfigs = async () => {
  try {
    return getFilteredWorkspaceData('/ratelimit/');
  } catch (error) {
    console.error("Error fetching rate limit:", error);
    throw error;
  }
};

export const getRateLimitConfigbyId = async (id) => {
  try {
    const response = await workspace.get(`/rate-limit/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching rate limit:", error);
    throw error;
  }
};

export const createRateLimit = async (id, rateData) => {
  try {
    const response = await workspace.post(`/rate-limit/${id}/`, rateData);
    return response.data;
  } catch (error) {
    console.error("Error creating rate limit :", error);
    throw error;
  }
}

export const updateRateLimit = async (rateId, rateData) => {
  try {
    const response = await workspace.put(`/ratelimit/${rateId}/`, rateData);
    return response.data;
  } catch (error) {
    console.error(`Error updating rate limit with ID ${rateId}:`, error);
    throw error;
  }
};

export const deleteRateLimit = async (rateId, rateData) => {
  try {
    const response = await workspace.delete(`/ratelimit/${rateId}/`, rateData);
    return response.data;
  } catch (error) {
    console.error(`Error updating rate limit with ID ${rateId}:`, error);
    throw error;
  }
};